import _ from 'lodash'
import { takeLatest, select, put, call, take } from 'redux-saga/effects'
import VALUES from 'core/data-model/constants/values'
import {
  getInsuredDCAProps,
  getRecurringPayment,
  getDCA,
  isCloneATPtoDCA,
  getPolicyId,
  isDCASelected,
  isShowDCASelected,
} from 'e-submission/domain/data-model/form/selectors'

import { hideLoading, setAppValue, showLoading, clonePhoto, fetchSignature } from 'e-submission/apps/actions'

import { getIdentityUser } from 'identity/selectors'

import { getCurrentApp } from 'e-submission/apps/selectors'

import { confirmDialog, confirmDialogDCA } from './confirm'

export const setDefaultDCA = function*(service, action) {
  const app = yield select(getCurrentApp)

  try {
    yield put.resolve(showLoading())

    yield put(setAppValue('DCA.status', VALUES.DCA_STATUS.INFORMATION))

    const insured = getInsuredDCAProps(app)
    const { isPayer } = app.insured

    if (!isPayer) {
      yield put(setAppValue('DCA.firstName', app?.payer?.firstName))
      yield put(setAppValue('DCA.lastName', app?.payer?.lastName))
      yield put(setAppValue('DCA.title', app?.payer?.title.text))
      yield put(setAppValue('DCA.bank', VALUES.DCA_DEFAULT_BANK))
      yield put(
        setAppValue('DCA.dcaType', {
          text: 'บัญชีธนาคาร',
          value: 'BANK_ACCOUNT',
        })
      )
    } else {
      yield put(setAppValue('DCA.firstName', insured.firstName))
      yield put(setAppValue('DCA.lastName', insured.lastName))
      yield put(setAppValue('DCA.title', insured.title))
      yield put(
        setAppValue('DCA.dcaType', {
          text: 'บัญชีธนาคาร',
          value: 'BANK_ACCOUNT',
        })
      )
      yield put(setAppValue('DCA.bank', VALUES.DCA_DEFAULT_BANK))
    }
    // Yoot log
    if (isCloneATPtoDCA(app)) {
      const ATP = getRecurringPayment(app)
      const accountNumber = _.get(ATP, 'bankBookNumber')
      yield put(setAppValue('DCA.accountNumber', accountNumber))
      yield [put(clonePhoto('bank-book', 'dca-bank-book')), take('LOAD_APP')]
    }
  } catch (err) {
  } finally {
    yield put(hideLoading())
  }
}

export const onUpdateDCA = function*(service, action) {
  const { updateDCA } = service

  const user = yield select(getIdentityUser)
  const app = yield select(getCurrentApp)

  try {
    yield put.resolve(showLoading())

    const dca = getDCA(app)
    const policyId = getPolicyId(app)
    const tranformDca = _.omit(dca, ['isAccountChecked'])

    //! in case there is a payer, if not send payer info with payload
    const { isPayer } = app.insured
    const isInsuredHasPayer = !isPayer // true คือ insured มี payer

    const payerInfoForDca = isInsuredHasPayer
      ? {
          title: app.payer.title,
          idType: app.payer.idType,
          firstName: app.payer.firstName,
          lastName: app.payer.lastName,
          idNo: app.payer.idNo,
          relationshipToInsured: app.payer.relationshipToInsured,
        }
      : undefined

    const isBankAccount = tranformDca.dcaType.value === 'BANK_ACCOUNT'
    const isPayerAndSelectedPromptpay = isInsuredHasPayer && !isBankAccount
    const isInsuredAndSelectedPromptpay = !isInsuredHasPayer && !isBankAccount

    let accountNamePayload

    if (isBankAccount) {
      accountNamePayload = tranformDca.accountName
    } else if (isPayerAndSelectedPromptpay) {
      accountNamePayload = `${payerInfoForDca.title.text} ${payerInfoForDca.firstName} ${payerInfoForDca.lastName}`
    } else if (isInsuredAndSelectedPromptpay) {
      accountNamePayload = `${tranformDca.title.text} ${tranformDca.firstName} ${tranformDca.lastName}`
    }

    const params = {
      ...tranformDca,
      policyId,
      accountStatus: _.get(dca, 'isAccountChecked.status'),
      payerInfoForDca,
      accountNumber: isBankAccount ? dca?.accountNumber : dca?.idNo?.citizenId,
      dcaType: dca?.dcaType,
      accountName: accountNamePayload,
    }

    yield call(updateDCA, user, params)
    yield [put(fetchSignature()), take('HIDE_LOADING')]
    yield put(setAppValue('DCA.status', VALUES.DCA_STATUS.UNSIGHED))
  } catch (err) {
    console.error(err)
  } finally {
    yield put(hideLoading())
  }
}

export const onSignedDCA = function*(service, history, action) {
  const { signedDCA } = service

  const user = yield select(getIdentityUser)
  const app = yield select(getCurrentApp)

  try {
    yield put.resolve(showLoading())

    const dca = getDCA(app)
    const policyId = getPolicyId(app)
    const tranformDca = _.omit(dca, ['isAccountChecked'])

    const params = {
      ...tranformDca,
      policyId,
      accountStatus: _.get(dca, 'isAccountChecked.status'),
    }

    yield call(signedDCA, user, params)
    yield put(setAppValue('DCA.status', VALUES.DCA_STATUS.SIGNED))
  } catch (err) {
    console.error(err)
  } finally {
    yield put(hideLoading())
  }
}

export const onCleanDCA = function*(service, history, action) {
  const { cleanDCA } = service

  const user = yield select(getIdentityUser)
  const app = yield select(getCurrentApp)

  try {
    const isCleanDCA = !isDCASelected(app) && isShowDCASelected(app)
    if (isCleanDCA) {
      const policyId = getPolicyId(app)
      yield call(cleanDCA, user, { policyId })
    }
  } catch (err) {
    console.error(err)
  }
}

export const onConfirmDCA = function*(service, history, action) {
  const { confirmSubmitDCA } = service
  try {
    yield call(
      confirmDialogDCA,
      {
        title: 'การขอรับผลประโยชน์จากกรมธรรม์',
        body: `<p>กรุณาตรวจสอบข้อมูลก่อนกดปุ่ม ยืนยัน เพื่อขอรับผลประโยชน์ตามกรมธรรม์</p>`,
      },
      { onlyConfirm: true, confirmText: 'ยืนยัน', confirmYesWithAction: 'UPDATE_DCA' }
    )
  } catch (error) {
    console.error(error)
  }
}

export default function*(service, history) {
  yield [takeLatest('SET_DEFAULT_DCA', setDefaultDCA, service)]
  yield [takeLatest('UPDATE_DCA', onUpdateDCA, service)]
  yield [takeLatest('SIGNED_DCA', onSignedDCA, service, history)]
  yield [takeLatest('CLEAN_DCA', onCleanDCA, service, history)]
  yield [takeLatest('CONFIRM_SUBMIT_DCA', onConfirmDCA, service, history)]
}
